import { CleaveOptions } from 'cleave.js/options';
import Cleave from 'cleave.js/react';
import React from 'react';

interface CleaveInputProps {
  options: CleaveOptions;
  [x: string]: any;
}

/** Helper component for creating input components which format text while
 *  typing using [cleave.js](https://nosir.github.io/cleave.js/).
 *
 *  [Information](https://material-ui.com/components/text-fields/#integration-with-3rd-party-input-libraries)
 *  about integrating input libraries with MaterialUI. */
export const CleaveInput = ({ options, ...props }: CleaveInputProps) => {
  const { inputRef, ...rest } = props;

  return (
    <Cleave
      ref={(r: any) => {
        if (r) {
          inputRef(r.element);
        }
      }}
      {...rest}
      options={options}
    />
  );
};
